namespace AgerLMS.LMS {
    export interface CourseRow {
        CourseId?: number;
        CourseName?: string;
        InstructorId?: number;
        CourseDescription?: string;
        CourseType?: CourseTypes;
        CategoryId?: number;
        Price?: number;
        SalePrice?: number;
        Thumbnail?: string;
        CoverImage?: string;
        DemoVideoSource?: DemoVideoSources;
        DemoVideo?: string;
        DemoVideoUrl?: string;
        Downloadable?: boolean;
        Duration?: number;
        AccessPeriodDays?: number;
        Seo?: string;
        PublishDate?: string;
        SalesStatus?: SalesStatus;
        WatchCount?: number;
        UserBased?: boolean;
        ReleatedBook?: number;
        IncludesCargoPrice?: boolean;
        ReferenceCount?: number;
        WatchDay?: number;
        BookPageCount?: number;
        Prerequisites?: number[];
        StudentCount?: number;
        InstructorName?: string;
        CategoryCategoryName?: string;
        CategoryParentCategoryId?: number;
        CourseSectionCount?: number;
        OrderItemCount?: number;
        ReleatedBookProductTitle?: string;
        RelatedBookIncludesCargoPrice?: boolean;
        RelatedBookImage?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
        IsActive?: number;
        InsertUserDisplayName?: string;
    }

    export namespace CourseRow {
        export const idProperty = 'CourseId';
        export const isActiveProperty = 'IsActive';
        export const nameProperty = 'CourseName';
        export const localTextPrefix = 'LMS.Course';
        export const lookupKey = 'LMS.Course';

        export function getLookup(): Q.Lookup<CourseRow> {
            return Q.getLookup<CourseRow>('LMS.Course');
        }
        export const deletePermission = 'LMS:Course:Modify';
        export const insertPermission = 'LMS:Course:Modify';
        export const readPermission = 'LMS:Course:Read';
        export const updatePermission = 'LMS:Course:Modify';

        export declare const enum Fields {
            CourseId = "CourseId",
            CourseName = "CourseName",
            InstructorId = "InstructorId",
            CourseDescription = "CourseDescription",
            CourseType = "CourseType",
            CategoryId = "CategoryId",
            Price = "Price",
            SalePrice = "SalePrice",
            Thumbnail = "Thumbnail",
            CoverImage = "CoverImage",
            DemoVideoSource = "DemoVideoSource",
            DemoVideo = "DemoVideo",
            DemoVideoUrl = "DemoVideoUrl",
            Downloadable = "Downloadable",
            Duration = "Duration",
            AccessPeriodDays = "AccessPeriodDays",
            Seo = "Seo",
            PublishDate = "PublishDate",
            SalesStatus = "SalesStatus",
            WatchCount = "WatchCount",
            UserBased = "UserBased",
            ReleatedBook = "ReleatedBook",
            IncludesCargoPrice = "IncludesCargoPrice",
            ReferenceCount = "ReferenceCount",
            WatchDay = "WatchDay",
            BookPageCount = "BookPageCount",
            Prerequisites = "Prerequisites",
            StudentCount = "StudentCount",
            InstructorName = "InstructorName",
            CategoryCategoryName = "CategoryCategoryName",
            CategoryParentCategoryId = "CategoryParentCategoryId",
            CourseSectionCount = "CourseSectionCount",
            OrderItemCount = "OrderItemCount",
            ReleatedBookProductTitle = "ReleatedBookProductTitle",
            RelatedBookIncludesCargoPrice = "RelatedBookIncludesCargoPrice",
            RelatedBookImage = "RelatedBookImage",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate",
            IsActive = "IsActive",
            InsertUserDisplayName = "InsertUserDisplayName"
        }
    }
}
